export default __webpack_public_path__ + "static/media/p2023-9.3950bcf9.jpeg";